import { FC } from "react";
import { Col, Row, Tag, Typography } from "antd";

import { Epoch } from "@ctra/utils";

import { Barn, Icon } from "../../../../../elements";

import styles from "./Title.module.less";

const { Text } = Typography;

export interface TitleProps {
  /**
   * Game plan farm name
   */
  farm: string;
  /**
   * Start date of the game plan
   */
  startDate: number;
}

/**
 * Game plan list entry title with due date and farm name
 * @param title
 */
const Title: FC<TitleProps> = ({ farm, startDate, children }) => {
  return (
    <Row gutter={[0, 8]}>
      <Col span={24}>
        <Text strong>{children}</Text>
      </Col>
      <Col span={24}>
        <Row align="middle">
          <Text className={styles.Date} type="secondary">
            {Epoch.asMoment(startDate).format("LL")}
          </Text>
          <Tag color="purple" className={styles.Tag}>
            <Text type="secondary">
              <Icon component={Barn} /> {farm}
            </Text>
          </Tag>
        </Row>
      </Col>
    </Row>
  );
};

export default Title;
